import { type Descendant, type Editor as SlateEditor, type Operation } from 'slate';

// @ts-expect-error Missing types
import { focusEditor } from 'src/components/RichSlate';

import { getEditorHtmlContent, getEditorTextContent } from './queries';
import {
  applyEditorTextChanges,
  replaceSlateEditorHtml,
  replaceSlateEditorText,
} from './transforms';
import type { EditorTextChange } from './types';

export const hasSlateContentChangeOperation = (operations: Operation[]): boolean =>
  operations.some((op) => 'set_selection' !== op.type);

export const hasSlateSelectionOperation = (operations: Operation[]): boolean =>
  operations.some((op) => 'set_selection' === op.type);

export const createEditorInstanceImperativeHandle = (editor: SlateEditor) => {
  return {
    applyTextChanges: (changes: EditorTextChange[]): void => {
      applyEditorTextChanges(editor, changes);
    },
    getEditor: (): SlateEditor => {
      return editor;
    },
    getValue: (): Descendant[] => {
      return editor.children;
    },
    getText: (): string => {
      return getEditorTextContent(editor);
    },
    getHtml: (): string => {
      return getEditorHtmlContent(editor);
    },
    replaceHtml: (newHtml: string): void => {
      replaceSlateEditorHtml(editor, newHtml);
    },
    replaceText: (newText: string): void => {
      replaceSlateEditorText(editor, newText);
    },
    focus: (atEnd = true): void => {
      if (editor) {
        focusEditor({ editor, atEnd });
      }
    },
  };
};
